import type { TFunction } from "i18next";
import type { Review } from "../../../api/content/reviewDecoders";
import { shortReference } from "../../../shared/references/shortReferences";
import type { DecisionAction } from "../state/decisionRules";

/** One name per action: on the decision bar and on the button that sends it. */
export const ACTION_LABEL_KEYS: Readonly<Record<DecisionAction, string>> = {
  approve: "reviews.decisions.actions.approve",
  request_changes: "reviews.decisions.actions.request_changes",
  scrap: "reviews.decisions.actions.scrap",
  merge: "reviews.merge.action",
  resubmit: "reviews.decisions.resubmit",
};

/** What a merge rested on, as recorded: the approvals of the merged head, or none besides the merge. */
export function mergeApprovalText(approvers: readonly string[], nameOf: (userId: string) => string, t: TFunction, language: string | undefined): string {
  if (approvers.length === 0) return t("reviews.decisions.mergeApprovals.none");
  const names = new Intl.ListFormat(language, { type: "conjunction" }).format(approvers.map(nameOf));
  return t("reviews.decisions.mergeApprovals.by", { names });
}

/** A changed item's name; its short ID if the review doesn't list it. */
export function changedItemName(review: Review, itemId: string): string {
  return review.items.find((item) => item.itemId === itemId)?.name ?? shortReference("itemId", itemId);
}
